export default interface RegistrationDocument {
    doc_id: string,
    username: string,
    doc_name: string,
    file_type: string,
    signed_url: string,
    uploaded_at: string,
    verified_by?: string,
    verified_at?: string,
    status: string,
    comment?: string,
};

export enum RegistrationDocumentStatus {
    PENDING_REVIEW = "PENDING_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
};